<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import dynamicRouter from '@/router/dynamic-router'
import router, { DynamicRoutes } from '@/router/index'
import PageIndex from '@/pages/PageIndex'
import Index from '@/pages/Index'
import axios from 'axios'
export default {
  name: 'App',
  beforeCreate () { // 在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
    // this.$commonFunc.myConsole('beforeCreate ======> App')
    // 获取 apiServerHost--仅开发阶段使用
    // if (this.$config.BASE === 'development') {
      this.$config.getApiServerHost()
    // } 
    // 获取并设置相关本地数据源
    let localUserInfoData = sessionStorage.getItem('userInfoObj')
    // this.$commonFunc.myConsole('localUserInfoData ====== >')
    // this.$commonFunc.myConsole(localUserInfoData)
    if(this.$commonFunc.isDefine(localUserInfoData)){
      this.$store.dispatch('userInfo/doSetLogin')
    } else {
        this.$router.push("/")
    }
    //刷新页面时，重新设一遍路由、重新设置token
    if(this.$store.state.userInfo.isLogin) {

        let authorityList = this.$store.state.userInfo.userInfoObj.authorityList
        let matchRouter = this.$commonFunc.recursionRouter(authorityList, dynamicRouter)
        let routers = [{
            path: '/index',
            name: 'PageIndex',
            component: PageIndex,
            meta: {
              requireAuth: true
            },
            children: [
                {
                    path: '/index',
                    name: 'Index',
                    component: Index
                }]
        }]
        routers[0].children.push(...matchRouter)
        this.$router.addRoutes(routers)
        axios.defaults.headers.common['accept-language'] = sessionStorage.getItem('defaultLang')
    }
  },
  beforeUpdate () { // 数据更新时调用，发生在虚拟 DOM 打补丁之前。这里适合在更新之前访问现有的 DOM，比如手动移除已添加的事件监听器。
    // this.$commonFunc.myConsole('beforeUpdate ======> App')
    // 获取 apiServerHost--仅开发阶段使用
    //if (this.$config.BASE === 'development') {
      this.$config.getApiServerHost()
    //} 
  }
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-top: 0px;
    background-color: #F3F3F3;
    height: 100%;
    overflow-x:hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue